import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ThankYouProgress from '../components/ThankYouProgress';
import ThankYouSteps from '../components/ThankYouSteps';
import QuizCard from '../components/QuizCard';
import { sendMetaCapiEvent } from '../services/metaApi';

const ThankYou = () => {
  useEffect(() => {
    // 1. Disparo via Pixel do Navegador (Standard)
    if (window.fbq) {
      window.fbq('track', 'Lead');
      window.fbq('track', 'CompleteRegistration');
    }

    // 2. Disparo via API de Conversões (CAPI)
    sendMetaCapiEvent('Lead');
    sendMetaCapiEvent('CompleteRegistration');
    
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex flex-col items-center py-12 px-6 overflow-hidden relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-gradient-to-b from-amber-100/30 to-transparent pointer-events-none" />
      
      <div className="max-w-3xl w-full relative z-10 text-center">
        <motion.div 
          initial={{ opacity: 0, y: -20 }} 
          animate={{ opacity: 1, y: 0 }} 
          className="mb-12 flex flex-col items-center"
        >
          <img 
            src="https://i.imgur.com/LJ9Fcbk.png" 
            alt="UniPET Logo" 
            className="h-14 w-auto mb-4 object-contain drop-shadow-sm" 
          />
          <div className="h-px w-8 bg-amber-800/30 mt-2" />
        </motion.div>

        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.2 }}>
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8 shadow-sm">
            <SafeIcon name="Check" className="w-10 h-10 text-emerald-600" />
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-stone-900 mb-4 leading-tight">
            Cadastro Recebido!
          </h1>
          <p className="text-stone-600 text-lg mb-10 font-medium">
            Você está a apenas um passo de garantir o tratamento premium que seu pet merece.
          </p>
        </motion.div>

        <ThankYouProgress />
        <ThankYouSteps />
        
        {/* New Quiz Integration */}
        <QuizCard />

        <p className="mt-16 text-stone-400 text-[10px] uppercase tracking-[0.3em] font-bold">
          UniPET  • Juiz de Fora
        </p>
      </div>
    </div>
  );
};

export default ThankYou;